import React, { useState } from "react";
import {
  setNewTag,
  changeTagAction,
} from "store/reducers/products/parameters/parameters.actions";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "store";
import { HoveredInputCell, SearchableDropdown } from "components";
import { secureTrim } from "helpers/string";
import colors from "theme/colors";
import {
  TagKeys,
  TagCategoryOptions,
} from "store/reducers/products/parameters/pl-parameters.types";

export function SetNewTagInput({
  type = TagKeys.NAME,
  id,
}: {
  type: TagKeys;
  id?: string;
}) {
  const dispatch = useDispatch();
  const newTag = useTypedSelector((state) => state.products.parameters.newTag);

  const handleInputKeyChange = (event) => {
    dispatch(setNewTag(type, event.target.value));
  };

  return (
    <StyledInput
      placeholder={type}
      onChange={handleInputKeyChange}
      value={newTag[type]}
      id={id}
    />
  );
}

export function SetNewTagCategoryDropDown({ id }: { id: string }) {
  // Index 0 corresponds with "uncategorized".
  const [tagCategory, setTagCategory] = useState(TagCategoryOptions[0]);
  const dispatch = useDispatch();

  const handleDropdownSelect = (value, valueObject) => {
    dispatch(setNewTag(TagKeys.CATEGORY, value));
    setTagCategory(valueObject);
  };

  return (
    <SearchableDropdown
      multiselect={false}
      searchable
      options={TagCategoryOptions}
      value={tagCategory}
      handleValueChange={handleDropdownSelect}
      name="tagCategory"
      id={id}
      noShadow
      noHoverBorder
    />
  );
}

export const EditTagNameCell = ({ rowData }: { rowData: any; id?: any }) => {
  const dispatch = useDispatch();
  const handleSubmit = (val) => {
    dispatch(
      changeTagAction({
        ...rowData,
        name: secureTrim(val),
      })
    );
  };
  return (
    <HoveredInputCell
      initialContent={rowData.name}
      handleSubmit={handleSubmit}
      rows={1}
      width={"146px"}
    />
  );
};

export const EditTagDescriptionCell = ({
  rowData,
}: {
  rowData: any;
  id?: any;
}) => {
  const dispatch = useDispatch();
  const handleSubmit = (val) => {
    dispatch(
      changeTagAction({
        ...rowData,
        description: secureTrim(val),
      })
    );
  };
  return (
    <HoveredInputCell
      initialContent={rowData.description}
      handleSubmit={handleSubmit}
      rows={1}
      width={"146px"}
    />
  );
};

export const EditTagCategoryCell = ({
  rowData,
  id,
}: {
  rowData: any;
  id?: string;
}) => {
  const dispatch = useDispatch();
  const changeValue = (value) => {
    dispatch(
      changeTagAction({
        ...rowData,
        category: secureTrim(value),
      })
    );
  };

  return (
    <SearchableDropdown
      multiselect={false}
      searchable
      options={TagCategoryOptions}
      value={TagCategoryOptions.find(
        (categoryOption) => rowData.category === categoryOption.value
      )}
      handleValueChange={changeValue}
      name="tagCtegory"
      id={id}
      noShadow
      noHoverBorder
      backgroundColor={colors.tables.hoveredCell}
    />
  );
};

export const addTagFields = [
  {
    content: <SetNewTagInput type={TagKeys.NAME} id={"AddRowName"} />,
    style: {},
  },
  {
    content: (
      <SetNewTagInput type={TagKeys.DESCRIPTION} id={"AddRowDescription"} />
    ),
    style: {},
  },
  {
    content: <SetNewTagCategoryDropDown id={"AddRowCategory"} />,
    style: {},
  },
];

export const StyledInput = styled.input<any>`
  text-decoration: none;
  font-size: 14px;
  color: ${(props) => props.theme.colors.primary};
  outline: none;
  border: none;
  background: none;
  padding: 0;

  :disabled {
    cursor: not-allowed;
  }

  :focus {
    outline: none; /* Remove default outline and use border or box-shadow */
  }
`;
